import { capitalize } from 'lodash';
import { z } from 'zod';

export const requiredString = (name: string) =>
  z
    .string({ required_error: `${capitalize(name)} is required.` })
    .nonempty({ message: `${capitalize(name)} is required.` });
